// Month component
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

// const Month = ({ field, day, year, ...props }) => {
//     const currentDate = new Date();

//     const todayMinus18 = new Date();
//     todayMinus18.setFullYear(todayMinus18.getFullYear() - 18);

//     const maxMonth = year === todayMinus18.getFullYear().toString() ? todayMinus18.getMonth() + 1 : 12;

//     let cn = props.cn ? props.cn : '';

//     return (
//         <select {...field} name="month" className={`select-box ${cn}`} required="" aria-required="true" aria-invalid="false">
//             <option value="">Month</option>
//             {maxMonth >= 1 && <option value="01">Jan</option>}
//             {maxMonth >= 2 && <option value="02">Feb</option>}
//             {maxMonth >= 3 && <option value="03">Mar</option>}
//             {maxMonth >= 4 && <option value="04">Apr</option>}
//             {maxMonth >= 5 && <option value="05">May</option>}
//             {maxMonth >= 6 && <option value="06">Jun</option>}
//             {maxMonth >= 7 && <option value="07">Jul</option>}
//             {maxMonth >= 8 && <option value="08">Aug</option>}
//             {maxMonth >= 9 && <option value="09">Sep</option>}
//             {maxMonth >= 10 && <option value="10">Oct</option>}
//             {maxMonth >= 11 && <option value="11">Nov</option>}
//             {maxMonth >= 12 && <option value="12">Dec</option>}
//         </select>
//     );
// }

const monthOptions = [
  { value: "01", label: "Jan" },
  { value: "02", label: "Feb" },
  { value: "03", label: "Mar" },
  { value: "04", label: "Apr" },
  { value: "05", label: "May" },
  { value: "06", label: "Jun" },
  { value: "07", label: "Jul" },
  { value: "08", label: "Aug" },
  { value: "09", label: "Sep" },
  { value: "10", label: "Oct" },
  { value: "11", label: "Nov" },
  { value: "12", label: "Dec" },
];

const Month = ({ field, form, year, day, styles,onKeyDown, ...props }) => {
  const currentDate = new Date();
  const todayMinus18 = new Date();
  const { t } = useTranslation();
  todayMinus18.setFullYear(todayMinus18.getFullYear() - 18);
  const maxMonth =
    year === todayMinus18.getFullYear().toString()
      ? todayMinus18.getMonth() + 1
      : 12;

  const filteredOptions = monthOptions.slice(0, maxMonth);

  const handleChange = (selectedOption) => {
    form.setFieldValue(field.name, selectedOption?.value || "");
  };

  const selectedValue = monthOptions.find(
    (option) => option.value === field.value
  );
  let cn = props.cn ? props.cn : "";
  return (
    <Select
      options={filteredOptions}
      value={selectedValue}
      onChange={handleChange}
      onBlur={field.onBlur}
      placeholder={t("month")}
      name={field.name}
      styles={styles}
      maxMenuHeight={160} // roughly 5–7 items
      menuPlacement="auto"
      onKeyDown={onKeyDown}
    />
  );
};

// Day component

// const Day = ({ field, month, year, ...props }) => {
//     const daysInMonth = (year, month) => {
//         return new Date(year, month, 0).getDate(); // 0th day of next month gives last day of current month
//     };

//     // Get today's date
//     const currentDate = new Date();
//     const todayMinus18 = new Date(currentDate.getFullYear() - 18, currentDate.getMonth(), currentDate.getDate());

//     // Set default days (1 to 31)
//     const [days, setDays] = useState(Array.from({ length: 31 }, (_, i) => i + 1));
//     const [maxDay, setMaxDay] = useState(31); // Default to max 31 days

//     useEffect(() => {
//         if (month && year) {
//             // Calculate the number of days in the selected month and year
//             const daysCount = daysInMonth(year, month);
//             setMaxDay(daysCount);

//             // If the selected year and month are 18 years ago, restrict days accordingly
//             const selectedDate = new Date(year, month - 1); // month is 0-based in JS Date
//             if (
//                 year == todayMinus18.getFullYear() &&
//                 month == todayMinus18.getMonth() + 1 // JavaScript month is 0-indexed
//             ) {
//                 setMaxDay(todayMinus18.getDate()); // Set the max day to the day 18 years ago
//             } else {
//                 setMaxDay(daysCount); // Otherwise, set max days to the full month
//             }

//             // Set valid days based on the new maxDay
//             setDays(Array.from({ length: daysCount }, (_, i) => i + 1));
//         }
//     }, [month, year]); // Recalculate when month or year changes

//     let cn = props.cn ? props.cn : '';

//     return (
//         <select {...field} name="day" className={`select-box ${cn}`} required="" aria-required="true" aria-invalid="false">
//             <option value="">Day</option>
//             {days
//                 .filter((day) => day <= maxDay) // Filter out days greater than maxDay
//                 .map((day) => (
//                     <option key={day} value={day}>
//                         {day}
//                     </option>
//                 ))}
{
  /* {maxDay >= 1 && <option value="01" disabled={1 > maxDay}>1</option>}
            {maxDay >= 2 && <option value="02" disabled={2 > maxDay}>2</option>}
            {maxDay >= 3 && <option value="03" disabled={3 > maxDay}>3</option>}
            {maxDay >= 4 && <option value="04" disabled={4 > maxDay}>4</option>}
            {maxDay >= 5 && <option value="05" disabled={5 > maxDay}>5</option>}
            {maxDay >= 6 && <option value="06" disabled={6 > maxDay}>6</option>}
            {maxDay >= 7 && <option value="07" disabled={7 > maxDay}>7</option>}
            {maxDay >= 8 && <option value="08" disabled={8 > maxDay}>8</option>}
            {maxDay >= 9 && <option value="09" disabled={9 > maxDay}>9</option>}
            {maxDay >= 10 && <option value="10" disabled={10 > maxDay}>10</option>}
            {maxDay >= 11 && <option value="11" disabled={11 > maxDay}>11</option>}
            {maxDay >= 12&& <option value="12" disabled={12 > maxDay}>12</option>}
            {maxDay >= 13 && <option value="13" disabled={13 > maxDay}>13</option>}
            {maxDay >= 14 && <option value="14" disabled={14 > maxDay}>14</option>}
            {maxDay >= 15 && <option value="15" disabled={15 > maxDay}>15</option>}
            {maxDay >= 16 && <option value="16" disabled={16 > maxDay}>16</option>}
            {maxDay >= 17 && <option value="17" disabled={17 > maxDay}>17</option>}
            {maxDay >= 18 && <option value="18" disabled={18 > maxDay}>18</option>}
            {maxDay >= 19 && <option value="19" disabled={19 > maxDay}>19</option>}
            {maxDay >= 20 && <option value="20" disabled={20 > maxDay}>20</option>}
            {maxDay >= 21 && <option value="21" disabled={21 > maxDay}>21</option>}
            {maxDay >= 22 && <option value="22" disabled={22 > maxDay}>22</option>}
            {maxDay >= 23 && <option value="23" disabled={23 > maxDay}>23</option>}
            {maxDay >= 24&& <option value="24" disabled={24 > maxDay}>24</option>}
            {maxDay >= 25 && <option value="25" disabled={25 > maxDay}>25</option>}
            {maxDay >= 26 && <option value="26" disabled={26 > maxDay}>26</option>}
            {maxDay >= 27 && <option value="27" disabled={27 > maxDay}>27</option>}
            {maxDay >= 28 && <option value="28" disabled={28 > maxDay}>28</option>}
            {maxDay >= 29 && <option value="29" disabled={29 > maxDay}>29</option>}
            {maxDay >= 30 && <option value="30" disabled={30 > maxDay}>30</option>}
            {maxDay >= 31 && <option value="31" disabled={31 > maxDay}>31</option>} */
}
//         </select>
//     );
// }

const Day = ({ field, form, month, year, styles,onKeyDown, ...props }) => {
  const daysInMonth = (year, month) => {
    return new Date(year, month, 0).getDate(); // 0th day of next month = last day of current month
  };

  const currentDate = new Date();
  const todayMinus18 = new Date(
    currentDate.getFullYear() - 18,
    currentDate.getMonth(),
    currentDate.getDate()
  );
  const { t } = useTranslation();

  const [days, setDays] = useState(Array.from({ length: 31 }, (_, i) => i + 1));
  const [maxDay, setMaxDay] = useState(31);

  useEffect(() => {
    if (month && year) {
      const daysCount = daysInMonth(year, month);
      setMaxDay(daysCount);

      const selectedDate = new Date(year, month - 1);

      if (
        year == todayMinus18.getFullYear() &&
        month == todayMinus18.getMonth() + 1
      ) {
        setMaxDay(todayMinus18.getDate());
      } else {
        setMaxDay(daysCount);
      }

      setDays(Array.from({ length: daysCount }, (_, i) => i + 1));
    }
  }, [month, year]);

  const dayOptions = days
    .filter((d) => d <= maxDay)
    .map((day) => ({
      value: String(day), // No padding in value
      label: String(day), // Keep label padded for display
    }));

  const selectedValue = dayOptions.find((opt) => opt.value === field.value);

  const handleChange = (selectedOption) => {
    form.setFieldValue(field.name, selectedOption?.value || "");
  };

  return (
    <Select
      options={dayOptions}
      value={selectedValue}
      onChange={handleChange}
      onBlur={field.onBlur}
      placeholder={t("day")}
      name={field.name}
      styles={styles}
      maxMenuHeight={160} // roughly 5–7 items
      menuPlacement="auto"
      onKeyDown={onKeyDown}
    />
  );
};

// Year component

// const Year = ({ field, month, day, ...props }) => {

//     let cn = props.cn ? props.cn : '';

//     // Get the current year
//     const currentYear = new Date().getFullYear();
//     const todayMinus18 = new Date();
//     todayMinus18.setFullYear(todayMinus18.getFullYear() - 18);
//     const [maxYear, setMaxYear] = useState(todayMinus18.getFullYear());

//     useEffect(() => {
//         // If month and day are selected, calculate if the user is still 17 or already 18
//         if (month && day) {
//             const selectedDate = new Date(`${maxYear}-${month}-${day}`);

//             if (selectedDate > todayMinus18) {
//                 setMaxYear(maxYear - 1); // Adjust to the previous year if the selected date is less than 18 years ago
//             } else {
//                 setMaxYear(todayMinus18.getFullYear()); // Reset to the original max year
//             }
//         }
//     }, [month, day]);

//     // Generate an array of years from 1924 until the current year
//     const years = Array.from(new Array(maxYear - 1924), (val, index) => maxYear - index);

//     return (
//         <select {...field} name="year" className={`select-box ${cn}`} required="" aria-required="true" aria-invalid="false">
//             <option value="">Year</option>
//             {years.map((year) => (
//                 <option key={year} value={year}>
//                     {year}
//                 </option>
//             ))}
//         </select>
//     );
// };

const Year = ({ field, form, month, day, styles,onKeyDown, ...props }) => {
  const currentYear = new Date().getFullYear();
  const todayMinus18 = new Date();
  const { t } = useTranslation();
  todayMinus18.setFullYear(todayMinus18.getFullYear() - 18);

  const [maxYear, setMaxYear] = useState(todayMinus18.getFullYear());

  useEffect(() => {
    if (month && day) {
      const selectedDate = new Date(`${maxYear}-${month}-${day}`);
      if (selectedDate > todayMinus18) {
        setMaxYear(todayMinus18.getFullYear() - 1);
      } else {
        setMaxYear(todayMinus18.getFullYear());
      }
    }
  }, [month, day]);

  const years = Array.from(
    new Array(maxYear - 1924 + 1),
    (_, index) => maxYear - index
  );

  const yearOptions = years.map((year) => ({
    value: year.toString(),
    label: year.toString(),
  }));

  const selectedValue = yearOptions.find((opt) => opt.value === field.value);

  const handleChange = (selectedOption) => {
    form.setFieldValue(field.name, selectedOption?.value || "");
  };

  return (
    <Select
      options={yearOptions}
      value={selectedValue}
      onChange={handleChange}
      onBlur={field.onBlur}
      placeholder={t("year")}
      name={field.name}
      styles={styles}
      maxMenuHeight={160} // ~5–7 items
      menuPlacement="auto"
      onKeyDown={onKeyDown}
    />
  );
};

// Country component

const Country = ({ field, ...props }) => {
  let cn = props.cn ? props.cn : "";

  return (
    <select
      {...field}
      name={props?.name ? props?.name : "country"}
      className={`select-box ${cn}`}
      required=""
      aria-required="true"
      aria-invalid="false"
    >
      <option value="">Select Country</option>
      {/* <option value="AF">Afghanistan</option>
            <option value="AX">Aland Islands</option>
            <option value="AL">Albania</option>
            <option value="DZ">Algeria</option>
            <option value="AS">American Samoa</option>
            <option value="AD">Andorra</option>
            <option value="AO">Angola</option>
            <option value="AI">Anguilla</option>
            <option value="AQ">Antarctica</option>
            <option value="AG">Antigua And Barbuda</option>
            <option value="AR">Argentina</option>
            <option value="AM">Armenia</option>
            <option value="AW">Aruba</option>
            <option value="AU">Australia</option>
            <option value="AT">Austria</option>
            <option value="AZ">Azerbaijan</option>
            <option value="BS">Bahamas</option>
            <option value="BH">Bahrain</option>
            <option value="BD">Bangladesh</option>
            <option value="BB">Barbados</option>
            <option value="BY">Belarus</option>
            <option value="BE">Belgium</option>
            <option value="BZ">Belize</option>
            <option value="BJ">Benin</option>
            <option value="BM">Bermuda</option>
            <option value="BT">Bhutan</option>
            <option value="BO">Bolivia</option>
            <option value="BA">Bosnia And Herzegovina</option>
            <option value="BW">Botswana</option>
            <option value="BV">Bouvet Island</option>
            <option value="BR">Brazil</option>
            <option value="IO">British Indian Ocean Territory</option>
            <option value="BN">Brunei Darussalam</option>
            <option value="BG">Bulgaria</option>
            <option value="BF">Burkina Faso</option>
            <option value="BI">Burundi</option>
            <option value="KH">Cambodia</option>
            <option value="CM">Cameroon</option> */}
      <option value="CA">Canada</option>
      {/* <option value="CV">Cape Verde</option>
            <option value="KY">Cayman Islands</option>
            <option value="CF">Central African Republic</option>
            <option value="TD">Chad</option>
            <option value="CL">Chile</option>
            <option value="CN">China</option>
            <option value="CX">Christmas Island</option>
            <option value="CC">Cocos (Keeling) Islands</option>
            <option value="CO">Colombia</option>
            <option value="KM">Comoros</option>
            <option value="CG">Congo</option>
            <option value="CD">Congo, Democratic Republic</option>
            <option value="CK">Cook Islands</option>
            <option value="CR">Costa Rica</option>
            <option value="CI">Cote D'Ivoire</option>
            <option value="HR">Croatia</option>
            <option value="CU">Cuba</option>
            <option value="CY">Cyprus</option>
            <option value="CZ">Czech Republic</option>
            <option value="DK">Denmark</option>
            <option value="DJ">Djibouti</option>
            <option value="DM">Dominica</option>
            <option value="DO">Dominican Republic</option>
            <option value="EC">Ecuador</option>
            <option value="EG">Egypt</option>
            <option value="SV">El Salvador</option>
            <option value="GQ">Equatorial Guinea</option>
            <option value="ER">Eritrea</option>
            <option value="EE">Estonia</option>
            <option value="ET">Ethiopia</option>
            <option value="FK">Falkland Islands (Malvinas)</option>
            <option value="FO">Faroe Islands</option>
            <option value="FJ">Fiji</option>
            <option value="FI">Finland</option>
            <option value="FR">France</option>
            <option value="GF">French Guiana</option>
            <option value="PF">French Polynesia</option>
            <option value="TF">French Southern Territories</option>
            <option value="GA">Gabon</option>
            <option value="GM">Gambia</option>
            <option value="GE">Georgia</option>
            <option value="DE">Germany</option>
            <option value="GH">Ghana</option>
            <option value="GR">Greece</option>
            <option value="GL">Greenland</option>
            <option value="GD">Grenada</option>
            <option value="GP">Guadeloupe</option>
            <option value="GU">Guam</option>
            <option value="GT">Guatemala</option>
            <option value="GG">Guernsey</option>
            <option value="GN">Guinea</option>
            <option value="GW">Guinea-Bissau</option>
            <option value="GY">Guyana</option>
            <option value="HT">Haiti</option>
            <option value="HM">Heard Island &amp; Mcdonald Islands</option>
            <option value="VA">Holy See (Vatican City State)</option>
            <option value="HN">Honduras</option>
            <option value="HK">Hong Kong</option>
            <option value="HU">Hungary</option>
            <option value="IS">Iceland</option>
            <option value="IN" selected="selected">India</option>
            <option value="ID">Indonesia</option>
            <option value="IR">Iran, Islamic Republic Of</option>
            <option value="IQ">Iraq</option>
            <option value="IE">Ireland</option>
            <option value="IM">Isle Of Man</option>
            <option value="IL">Israel</option>
            <option value="IT">Italy</option>
            <option value="JM">Jamaica</option>
            <option value="JP">Japan</option>
            <option value="JE">Jersey</option>
            <option value="JO">Jordan</option>
            <option value="KZ">Kazakhstan</option>
            <option value="KE">Kenya</option>
            <option value="KR">Korea</option>
            <option value="KW">Kuwait</option>
            <option value="KG">Kyrgyzstan</option>
            <option value="LA">Lao People's Democratic Republic</option>
            <option value="LV">Latvia</option>
            <option value="LB">Lebanon</option>
            <option value="LS">Lesotho</option>
            <option value="LR">Liberia</option>
            <option value="LY">Libyan Arab Jamahiriya</option>
            <option value="LI">Liechtenstein</option>
            <option value="LT">Lithuania</option>
            <option value="LU">Luxembourg</option>
            <option value="MO">Macao</option>
            <option value="MK">Macedonia</option>
            <option value="MG">Madagascar</option>
            <option value="MW">Malawi</option>
            <option value="MY">Malaysia</option>
            <option value="MV">Maldives</option>
            <option value="ML">Mali</option>
            <option value="MT">Malta</option>
            <option value="MH">Marshall Islands</option>
            <option value="MQ">Martinique</option>
            <option value="MR">Mauritania</option>
            <option value="MU">Mauritius</option>
            <option value="YT">Mayotte</option>
            <option value="MX">Mexico</option>
            <option value="FM">Micronesia, Federated States Of</option>
            <option value="MD">Moldova</option>
            <option value="MC">Monaco</option>
            <option value="MN">Mongolia</option>
            <option value="ME">Montenegro</option>
            <option value="MS">Montserrat</option>
            <option value="MA">Morocco</option>
            <option value="MZ">Mozambique</option>
            <option value="MM">Myanmar</option>
            <option value="NA">Namibia</option>
            <option value="NR">Nauru</option>
            <option value="NP">Nepal</option>
            <option value="NL">Netherlands</option>
            <option value="NC">New Caledonia</option>
            <option value="NZ">New Zealand</option>
            <option value="NI">Nicaragua</option>
            <option value="NE">Niger</option>
            <option value="NG">Nigeria</option>
            <option value="NU">Niue</option>
            <option value="NF">Norfolk Island</option>
            <option value="MP">Northern Mariana Islands</option>
            <option value="NO">Norway</option>
            <option value="OM">Oman</option>
            <option value="PK">Pakistan</option>
            <option value="PW">Palau</option>
            <option value="PS">Palestinian Territory, Occupied</option>
            <option value="PA">Panama</option>
            <option value="PG">Papua New Guinea</option>
            <option value="PY">Paraguay</option>
            <option value="PE">Peru</option>
            <option value="PH">Philippines</option>
            <option value="PN">Pitcairn</option>
            <option value="PL">Poland</option>
            <option value="PT">Portugal</option>
            <option value="PR">Puerto Rico</option>
            <option value="QA">Qatar</option>
            <option value="RE">Reunion</option>
            <option value="RO">Romania</option>
            <option value="RU">Russian Federation</option>
            <option value="RW">Rwanda</option>
            <option value="BL">Saint Barthelemy</option>
            <option value="SH">Saint Helena</option>
            <option value="KN">Saint Kitts And Nevis</option>
            <option value="LC">Saint Lucia</option>
            <option value="MF">Saint Martin</option>
            <option value="PM">Saint Pierre And Miquelon</option>
            <option value="VC">Saint Vincent And Grenadines</option>
            <option value="WS">Samoa</option>
            <option value="SM">San Marino</option>
            <option value="ST">Sao Tome And Principe</option>
            <option value="SA">Saudi Arabia</option>
            <option value="SN">Senegal</option>
            <option value="RS">Serbia</option> */}
      <option value="SC">Seychelles</option>
      <option value="SL">Sierra Leone</option>
      <option value="SG">Singapore</option>
      {/* <option value="SK">Slovakia</option>
            <option value="SI">Slovenia</option>
            <option value="SB">Solomon Islands</option>
            <option value="SO">Somalia</option>
            <option value="ZA">South Africa</option>
            <option value="GS">South Georgia And Sandwich Isl.</option>
            <option value="ES">Spain</option>
            <option value="LK">Sri Lanka</option>
            <option value="SD">Sudan</option>
            <option value="SR">Suriname</option>
            <option value="SJ">Svalbard And Jan Mayen</option>
            <option value="SZ">Swaziland</option>
            <option value="SE">Sweden</option>
            <option value="CH">Switzerland</option>
            <option value="SY">Syrian Arab Republic</option>
            <option value="TW">Taiwan</option>
            <option value="TJ">Tajikistan</option>
            <option value="TZ">Tanzania</option>
            <option value="TH">Thailand</option>
            <option value="TL">Timor-Leste</option>
            <option value="TG">Togo</option>
            <option value="TK">Tokelau</option>
            <option value="TO">Tonga</option>
            <option value="TT">Trinidad And Tobago</option>
            <option value="TN">Tunisia</option>
            <option value="TR">Turkey</option>
            <option value="TM">Turkmenistan</option>
            <option value="TV">Tuvalu</option>
            <option value="UG">Uganda</option>
            <option value="UA">Ukraine</option> */}
      <option value="AE">United Arab Emirates</option>
      <option value="GB">United Kingdom</option>
      <option value="US">United States</option>
      <option value="UM">United States Outlying Islands</option>
      <option value="UY">Uruguay</option>
      {/* <option value="UZ">Uzbekistan</option>
            <option value="VU">Vanuatu</option>
            <option value="VE">Venezuela</option>
            <option value="VN">Viet Nam</option>
            <option value="VG">Virgin Islands, British</option>
            <option value="VI">Virgin Islands, U.S.</option>
            <option value="WF">Wallis And Futuna</option>
            <option value="EH">Western Sahara</option>
            <option value="YE">Yemen</option>
            <option value="ZM">Zambia</option>
            <option value="ZW">Zimbabwe</option>
            <option value="IC">Canary Islands</option> */}
    </select>
  );
};

// State component

const State = ({ field, ...props }) => {
  let cn = props.cn ? props.cn : "";

  return (
    <select
      {...field}
      name={props?.name ? props.name : "state"}
      className={`select-box ${cn}`}
      required=""
      aria-required="true"
      aria-invalid="false"
    >
      <option selected="selected" value="">
        Select State
      </option>
      <option value="1">Andaman &amp; Nicobar Islands</option>
      <option value="2">Andhra Pradesh</option>
      <option value="30">Arunachal Pradesh</option>
      <option value="3">Assam</option>
      <option value="34">Bihar</option>
      <option value="5">Chandigarh</option>
      <option value="37">Chattisgarh</option>
      <option value="6">Dadra &amp; Nagar Haveli</option>
      <option value="32">Daman &amp; Diu</option>
      <option value="7">Delhi</option>
      <option value="33">Goa</option>
      <option value="9">Gujarat</option>
      <option value="10">Haryana</option>
      <option value="11">Himachal Pradesh</option>
      <option value="12">Jammu &amp; Kashmir</option>
      <option value="38">Jharkhand</option>
      <option value="19">Karnataka</option>
      <option value="13">Kerala</option>
      <option value="14">Lakshadweep</option>
      <option value="35">Madhya Pradesh</option>
      <option value="16">Maharashtra</option>
      <option value="17">Manipur</option>
      <option value="18">Meghalaya</option>
      <option value="31">Mizoram</option>
      <option value="20">Nagaland</option>
      <option value="21">Odisha</option>
      <option value="22">Pondicherry</option>
      <option value="23">Punjab</option>
      <option value="24">Rajasthan</option>
      <option value="29">Sikkim</option>
      <option value="25">Tamil Nadu</option>
      <option value="40">Telangana</option>
      <option value="26">Tripura</option>
      <option value="36">Uttar Pradesh</option>
      <option value="39">Uttarakhand</option>
      <option value="28">West Bengal</option>
    </select>
  );
};

export { Month, Day, Year, Country, State };
